/**
 * Check for if object is empty or not.
 * @return {boolean} true if object is undefined or empty, else false
 */
const isEmpty = (obj) => !obj || Object.keys(obj).length === 0;
export default isEmpty;
//# sourceMappingURL=isEmpty.js.map